export const ignore = "aB0n$c";
export default {ignore};